import { Link } from "react-router-dom"
import "./BackToTopButton.css"


export default function BackToTopButton(){

    return(
        <Link id="backToTopButton" to={"/#invite"}/>
    )
}